export enum qualificationsActionType {
  SET_QUALIFICATIONS = 'SET_QUALIFICATIONS',
  SET_QUALIFICATIONS_BORROWER = 'SET_QUALIFICATIONS_BORROWER',
  UPDATE_QUALIFICATION = 'UPDATE_QUALIFICATION',
  UPDATE_PERSON_QUALIFICATION = 'UPDATE_PERSON_QUALIFICATION',
  SET_STATUS_OPTIONS = 'SET_STATUS_OPTIONS',
  SET_STATUS_OPTIONS_PERSON = 'SET_STATUS_OPTIONS_PERSON',
  SELECT_QUALIFICATION = 'SELECT_QUALIFICATION',
}
